import * as localeDictionary from 'plotly.js/lib/locales/fr';
import React, { useMemo } from 'react';
import BibliothequePlotly from '../BibliothequePlotly/BibliothequePlotly';

const GrapheCirculaire = ({
  donnees = [],
  configuration = {},
  viewobj_json_content,
  dimensionWidth,
  dimensionHeight,
  donneesGraphe,
  switchAfficherModifierIntervalle,
}) => {
  // Memoized data processing
  const { values, labels, colors } = useMemo(() => {
    const processedValues = [];
    const processedLabels = [];
    const processedColors = [];

    donnees.forEach((courbe) => {
      if (courbe.y.length > 0) {
        processedValues.push(courbe.y[courbe.y.length - 1]);
        processedLabels.push(
          courbe.name !== '' ? courbe.name : courbe.sensor_name + courbe.prefix
        );
        processedColors.push(courbe.color);
      }
    });

    return {
      values: processedValues,
      labels: processedLabels,
      colors: processedColors,
    };
  }, [donnees]);

  // Memoized configuration
  const { jsonLayout, styleData, showlegend } = useMemo(
    () => ({
      jsonLayout: viewobj_json_content?.layout || {},
      styleData: viewobj_json_content?.styleData || {},
      showlegend:
        configuration.showlegend === undefined
          ? true
          : configuration.showlegend === 1,
    }),
    [viewobj_json_content, configuration.showlegend]
  );

  // Plot data configuration
  const data = [
    {
      type: 'pie',
      values,
      labels: labels.map((v) => v + '      '),
      marker: {
        colors,
      },
      textinfo: 'label+percent',
      insidetextorientation: 'radial',
      hole: 0.4,
      ...styleData,
    },
  ];

  // Layout configuration
  const layout = {
    title: {
      text: `${configuration.title}<br>${configuration.subtitle}`,
    },
    responsive: true,
    width: dimensionWidth || window.innerWidth * 0.75,
    height: dimensionHeight || window.innerHeight * 0.85,
    showlegend,
    legend: {
      x: 1.05,
      y: 1,
      borderwidth: 2,
      entrywidthmode: 'pixels',
      entrywidth: 20,
    },
    modebar: {
      orientation: 'h',
      bgcolor: 'rgba(0, 0, 0, 0)',
      color: 'black',
      activecolor: '#f0af00',
    },
    ...jsonLayout,
  };

  // Plot configuration
  const config = {
    locales: { fr: localeDictionary },
    locale: 'fr',
    displayModeBar:
      !viewobj_json_content ||
      viewobj_json_content.length === 0 ||
      viewobj_json_content.displayModeBar === true,
    displaylogo: false,
    modeBarButtonsToRemove: [''],
  };

  return (
    <BibliothequePlotly
      data={data}
      layout={layout}
      donneesGraphe={donneesGraphe}
      ouvrirPopupModifierIntervalle={switchAfficherModifierIntervalle}
      dimensionWidth={dimensionWidth}
      dimensionHeight={dimensionHeight}
      viewobj_json_content={viewobj_json_content}
      config={config}
    />
  );
};

export default GrapheCirculaire;
